import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { PermissionCheck } from "../../shared/permission";
import { AppointmentFilter } from "../../models/appointment-filter.model";
import { FiltersDialogController } from "./filters-dialog.component";

let AppointmentFiltersDialogComponent = {
    selector: "vcAppointmentFiltersDialog",
    templateUrl:
        "/angular/components/planner/appointment-filters.component.html",
    bindings: {
        filters: "=?",
        appointmentTab: "=",
    },
    controller: class AppointmentFiltersDialogController extends FiltersDialogController {
        // * bindings for typescript compiler *
        public filters: AppointmentFilter;
        public appointmentTab: string;
        // ************************************
        private $scope: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        public customTemplates: any;
        public permissionProvider: PermissionCheck;
        public showStatus: boolean = false;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            PermissionCheck: PermissionCheck,
            $timeout: any
        ) {
            super($timeout);
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.permissionProvider = PermissionCheck;
        }

        $onInit() {
            this.customTemplates = this.filters.getCustomDateTemplates(
                this.appointmentTab == "overdue"
            );
        }

        openUsersTeamsDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-widget-filter-users-teams-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Users or Teams Filter",
                    size: "med",
                    locals: {
                        filter: angular.copy(this.filters),
                        allowUnassigned: true,
                        defaultTab: "user",
                    },
                })
                .then((filters: any): void => {
                    this.filters.setData(filters);
                });
        }

        filterUnassigned(): void {
            this.filters.users = [null];
        }

        toggleStatus(): void {
            this.showStatus = !this.showStatus;
        }

        selectStatus(status: string): void {
            let index = this.filters.status.indexOf(status);
            if (index > -1) {
                this.filters.status.splice(index, 1);
            } else {
                this.filters.status.push(status);
            }
        }

        clear(): void {
            this.filters.reset();
        }
        cancel(): void {
            this.dialog.cancel();
        }

        save(): void {
            this.dialog.hide(this.filters);
        }
    },
};

angular
    .module("planner")
    .component(
        AppointmentFiltersDialogComponent.selector,
        AppointmentFiltersDialogComponent
    );
